import { createSimpleFunctional } from '@/util'

export const VListItemHeader = createSimpleFunctional('v-list-item-header')
